
export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {}
}


// WEBPACK FOOTER //
// ./src/store/modules/blog.js